// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/biouv50.jpg";
import thumb1 from "../assets/images/New-Products/extra/biouv-50.png";
import thumb2 from "../assets/images/New-Products/biouv50.jpg";
import thumb3 from "../assets/images/New-Products/extra/biouv-50.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>BioUV SPF 50</h2>
              <p className="sub-heading text-muted">ULTIMATE PROTECTION WITH FLAWLESS COVERAGE </p>
              <h5>Product Overview</h5>
              <p>
                BioUV 50 SPF is anhydrous tinted matte finish sunscreen gel which suits all skin tones.
                It has encapsulated Iron Oxide which protects the skin from High Energy Visible Light.
                It possesses micronized form of Zinc Oxide and Titanium Dioxide which works as SPF Booster.
                It also contains 3 unique complexes which provide protection against UVA-UVB, High Energy Visible Light and Infrared Radiation.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">BioUV SPF 50 ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>BioUV 50 SPF Gel provides physical protection against UVA-UVB sun rays and high energy visible light.</li>
                    <li>It can be used for post dermatological procedures.</li>
                    <li>It is non-greasy, with a soft peach-tinted matte finish that gives an even skin tone.</li>
                    <li>BioUV 50 SPF Gel is lightweight, long-lasting, non-comedogenic, hypoallergenic, and highly water-resistant.</li>
                    <li>It anchors quickly on the skin with high spreadability.</li>
                    <li>It is paraben free, sulphate free, phthalate free, petroleum oil free, and GMO free.</li>
                  </ul>


                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Take sufficient quantity of BioUV 50 SPF Gel and apply liberally to cover the exposed areas.</li>
                      <li>Apply it 15–20 minutes before sun exposure.</li>
                      <li>Reapplication is needed after every 2–3 hours.</li>
                      <li>Avoid contact with eyes.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Iron oxide 3%</strong>: Provides effective protection against HEVL. Tinted mineral sunscreens are more beneficial than non-tinted ones since they protect against UV and visible light. Sunscreens with iron oxides aid in treating melasma and prevent hyperpigmentation, including in dark-skinned individuals (Fitzpatrick skin types IV–VI).</li>

                      <li><strong>Zinc Oxide 6%</strong>: Blocks both UVA & UVB radiations and also provides protection against blue light.</li>

                      <li><strong>Titanium dioxide 5%</strong>: ZnO and TiO₂ together provide broad-spectrum protection against UVA & UVB radiations.</li>

                      <li><strong>Galshield UV Care – 10%</strong>: A light-yellow low-viscosity liquid that prevents UV filter degradation, enhances SPF, and provides protection against UVA & UVB rays.</li>

                      <li><strong>Liposhield</strong>: A fractionated melanin compound providing additional environmental defense against High Energy Visible Light (HEVL).</li>

                      <li><strong>Venuceane</strong>: An advanced anti-aging active offering UV and IR protection. Provides hydrating, moisturizing, nourishing, and repairing benefits.</li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
